import { SwapKiwi } from '@niftyhorde/swap-kiwi-contracts/typechain/SwapKiwi';
import { abi as SwapKiwiABI } from '@niftyhorde/swap-kiwi-contracts/artifacts/contracts/SwapKiwi.sol/SwapKiwi.json';
import deploymentsJSON from '@niftyhorde/swap-kiwi-contracts/deployments/deployments.json';
import { useWeb3React } from '@web3-react/core';
import { Contract } from 'ethers';
import { DeploymentJson } from '../../types/deployment';
import { ISwap } from '../../types/swap';

export const NETWORKS: { [chainId: number]: string } = {
  1: 'mainnet',
  4: 'rinkeby',
  5: 'goerli',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useContract = (address: string | undefined, ABI: any): Contract | null => {
  const { library, account } = useWeb3React();

  if (!address || !ABI || !library) return null;
  try {
    const signer = library.getSigner(account);
    return new Contract(address, ABI, signer);
  } catch (error) {
    console.error(`Failed to connect to contract ${address}: `, error.message());
    return null;
  }
};

export const getKiwiContractAddressV1_0_2 = (chainId: number): string => {
  return chainId in deploymentsJSON
    ? ((deploymentsJSON as unknown) as DeploymentJson)[chainId][NETWORKS[chainId]]?.contracts[
        'SwapKiwi'
      ].address.toLowerCase()
    : '';
};

export const useSwapContract = (address?: string): SwapKiwi | null => {
  const { chainId } = useWeb3React();
  if (!chainId) return null;

  const kiwiContractAddressV1_0_2 = getKiwiContractAddressV1_0_2(chainId);

  // If the active swap contract passed as param is the same as the contract address of a previous
  // contract, return the previous contract with the respective ABI and current chainId
  switch (address?.toLowerCase()) {
    // For new contracts add new cases here
    // case kiwiContractAddressV1_0_3:
    //   return useContract(address, SwapKiwiABIV1_0_3) as SwapKiwiV1_0_3;
    case kiwiContractAddressV1_0_2:
    case undefined: // if no address is passed, get current contract
      return useContract(getKiwiContractAddressV1_0_2(chainId), SwapKiwiABI) as SwapKiwi;
    default:
      return null;
  }
};

export const getKiwiContractAddress = (chainId: number, activeSwap?: ISwap): string => {
  switch (activeSwap?.contract.toLowerCase()) {
    // case getKiwiContractAddressV1_0_3(chainId).toLowerCase():
    //   return getKiwiContractAddressV1_0_3(chainId).toLowerCase();
    default:
      return getKiwiContractAddressV1_0_2(chainId).toLowerCase();
  }
};

export const isNetworkSupported = (chainId: number | undefined): boolean => {
  if (!chainId) return false;
  if (!((deploymentsJSON as unknown) as DeploymentJson)[chainId]) return false;
  return true;
};
